module.exports = __webpack_public_path__ + "img/gaultier-thumb.48ff7b0f.jpg";